import ajax from '@/utils/ajax.js'
export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    // 获取指定时间段的工作日志提交记录
    async getWorklogSubmitTime(ctx, params) {
      return await ajax.get('/webapi/performance/v1/worklog/submit-time', {
        params
      })
    },
  }
}
